<template>

<div align="justify">
    <!--<p class="h4" align="center">Сайт организации ООО "АИС"</p>-->
    <div align="justify" style="padding: 10px;">
        
        <h3 align="center">
        ПО DataMatrix. Описание продукта.
        </h3>
        
        <p>
            
            Приложение предназначено для сбора кодов маркировки с нескольких сканеров штрихкодов и отображения оперативной и итоговой информации
        </p>
        <p>
            Основные возможности
            <ul>
                <li style="list-style: disc;">Настройка параметров подключения сканера штрихкодов и параметров сопоставления кодов маркировки с номенклатурой;</li>
                <li style="list-style: disc;">Чтение кодов маркировки DataMatrix;</li>
                <li style="list-style: disc;">Вывод информации о кодах маркировки в интерфейсе оператора;</li>
                <li style="list-style: disc;">Сохранение кодов маркировки в базу данных.</li>
            </ul>
        </p>
        <p>
            Описание технических средств хранения ПО доступно по <a href="/docs/datamatrix/Описание технических средств хранения.pdf" target="_blank" rel="noopener">ссылке</a>.
        </p>
        <br>
        <h4 align="center">Внешний вид приложения</h4>
        <p align="center">
            <img src="/img/datamatrix/screen01.png" width="80%" />
        </p>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

